import { DataBind } from "./DataBind.js";
import { getCallback } from "./utils.js";
class DataComputed extends DataBind {
  static config = {
    name: "DataComputed",
    options: {
      compute: String
    }
  };
  get compute() {
    const { group, compute } = this.$options;
    return getCallback(group, `return ${compute};`);
  }
  set(value) {
    let newValue = value;
    try {
      newValue = this.compute(value, this.target);
    } catch (error) {
      console.error("Failed", error);
    }
    super.set(newValue, false);
  }
}
export {
  DataComputed
};
//# sourceMappingURL=DataComputed.js.map
